// const base_url = "http://localhost:8090";
// const base_url = "http://192.168.1.41:8080";
// const base_url = "http://localhost:8080";
const base_url = "https://java.ujjawalsrijan.com";
export default base_url;
